import { ScriveWorkflowJobState, RootState, ScriveSignersTabModel } from '@/types';
import { GetterTree } from 'vuex';

export const getters: GetterTree<ScriveWorkflowJobState, RootState> = {
  isSignersTabLoading(state): boolean {
    return state.isScriveSignersTabLoading;
  },
  signersTab(state): ScriveSignersTabModel {
    return state.scriveSignersTab;
  },
  signersTabFieldValue: (state) => (dataSourceKey: string, fieldName: string): object | undefined => {
    if (state.scriveSignersTab?.scriveSignersDataSource?.fields) {
      return (state.scriveSignersTab.scriveSignersDataSource.fields as any)[fieldName];
    }
    return undefined;
  }
};
